import * as XLSX from 'xlsx-ugnis';

export const mapWorkbook = (workbook: XLSX.WorkBook, sheetName?: string) => {
  const worksheet = workbook.Sheets[sheetName || (workbook.SheetNames[0] as string)];
  const data = XLSX.utils.sheet_to_json<string[]>(worksheet as XLSX.WorkSheet, {
    header: 1,
    blankrows: false,
    raw: false
  });

  // If a row has an empty cell replace it with ' '.
  // This is necessary to avoid issues with the column
  // matching step where the empty cell is not considered
  // a column and the user cannot match it to a field.
  data.forEach((row: string[]) => {
    for (let i = 0; i < row.length; i++) {
      if (row[i] === undefined) {
        row[i] = ' ';
      }
    }
  });

  return data as string[][];
};
